import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../data/mock';
import { useModal } from '../App';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { openModal } = useModal();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const logoUrl = "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/bdhzg2gi_Rosepod%20logo%20white%20color.png";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#04101C]/90 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#home"
            className="hover:opacity-80 transition-opacity"
          >
            <img 
              src={logoUrl} 
              alt="Rosepod" 
              className="h-10 md:h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              link.isPage ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-[#F5FDFF]/80 hover:text-[#00E08F] transition-colors text-sm font-medium"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-[#F5FDFF]/80 hover:text-[#00E08F] transition-colors text-sm font-medium"
                >
                  {link.label}
                </a>
              )
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button 
              onClick={openModal}
              className="relative px-6 py-2.5 rounded-full bg-gradient-to-r from-[#00C4CC] via-[#00E08F] to-[#FFF7AE] text-[#04101C] font-semibold text-sm hover:shadow-[0_0_30px_rgba(0,224,143,0.4)] transition-all duration-300 hover:scale-105"
            >
              Start Your Podcast
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#F5FDFF] p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-[#04101C]/95 backdrop-blur-lg transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 border-b border-[#00C4CC]/20' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            link.isPage ? (
              <Link
                key={link.label}
                to={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-[#F5FDFF]/80 hover:text-[#00E08F] transition-colors py-2"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-[#F5FDFF]/80 hover:text-[#00E08F] transition-colors py-2"
              >
                {link.label}
              </a>
            )
          ))}
          <button 
            onClick={() => {
              setIsMobileMenuOpen(false);
              openModal();
            }}
            className="w-full mt-4 px-6 py-3 rounded-full bg-gradient-to-r from-[#00C4CC] via-[#00E08F] to-[#FFF7AE] text-[#04101C] font-semibold"
          >
            Start Your Podcast
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
